import { Visible, Text, Heading } from '@leroy-merlin-br/backyard-react-ui'

import { useProfile } from 'catalog/hooks/use-profile'
import { StampLeroyWarrant } from 'catalog/pages/Product/components/StampLeroyWarrant'

import * as S from './styled'

const ExclusiveSaleSiteMessage = ({ visibility }) => {
  const { isLoadingProfile, isAssistedSale } = useProfile()

  if (isAssistedSale || isLoadingProfile) {
    return null
  }

  let visibleOn = {}

  if (visibility === 'desktop') {
    visibleOn = { mega: true, giga: true, tera: true }
  }

  if (visibility === 'mobile') {
    visibleOn = { untilKilo: true, kilo: true }
  }

  return (
    <Visible {...visibleOn}>
      <S.Wrapper>
        <Heading size="kilo" as="h5" noMargin>
          Vendido exclusivamente no site
        </Heading>

        <Text size="kilo" noMargin>
          Este produto é disponibilizado pela nossa loja parceira e pode ser
          comprado{' '}
          <Text size="kilo" as="strong" bold noMargin>
            exclusivamente através do nosso site. Aproveite!
          </Text>
        </Text>
      </S.Wrapper>

      <StampLeroyWarrant />
    </Visible>
  )
}

export default ExclusiveSaleSiteMessage
